import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainTextList from "./components/MainView/mainTextList";
import "./components/VideoIntro/videoIntro.css";
import SecondHeader from "./components/Header/secondHeader";
import PhotographersPage from "./components/PhotographersPage/photographersPage";
import DirectorsPage from "./components/DirectorsPage/directorsPage";
import PersonDetail from "./components/PersonDetail/personDetail";
import ContactPage from "./components/ContactPage/contactPage";
import AboutPage from "./components/AboutPage/aboutPage.js";
import JulWorks from "./components/JulWorks/julWorks.js";
import { useState } from "react";
import VideoIntro from "./components/VideoIntro/videoIntro.js";


function App() {

  const [showIntro, setShowIntro] = useState(true);

  const handleIntroFinish = () => {
    setShowIntro(false); // Video tamamlandığında ana sayfa yüklenir
  };


  return (
    <Router>
      {showIntro ? (
        <VideoIntro onFinish={handleIntroFinish} />
      ) : (
        <Routes>
          {/* Ana sayfa */}
          <Route
            path="/"
            element={
              <>
                <SecondHeader />
                <JulWorks />
              </>
            }
          />

        {/* Photographers sayfası */}
        <Route
          path="/photographers"
          element={
            <>
              <SecondHeader />
              <PhotographersPage />
            </>
          }
        />

        {/* Directors sayfası */}
        <Route
          path="/directors"
          element={
            <>
              <SecondHeader />
              <DirectorsPage />
            </>
          }
        />
      
       {/* Dinamik Detay Sayfaları */}
       <Route
          path="/photographers/:name"
          element={
            <>
              <SecondHeader />
              <PersonDetail />
            </>
          }
        />
        <Route
          path="/directors/:name"
          element={
            <>
              <SecondHeader />
              <PersonDetail />
            </>
          }
        />
        {/* Contact */}
        <Route
          path="/contact"
          element={
            <>
              <SecondHeader /> 
              <ContactPage />
            </>
          }
        />

         {/* About Sayfası */}
         <Route
          path="/about"
          element={
            <>
              <SecondHeader />
              <AboutPage />
            </>
          }
        />

        {/* JulWorks Sayfası */}
        <Route
          path="/jul"
          element={
            <>
              <SecondHeader />
              <JulWorks />
            </>
          }
        />

        {/* MainTextList Sayfası */}
        <Route
            path="/home"
            element={
              <>
                <SecondHeader />
                <MainTextList />
              </>
            }
          />

        </Routes> 

        
      )}
    </Router>
  );
}

export default App;
